import { render, staticRenderFns } from "./TheAttachmentsList.vue?vue&type=template&id=49a7793c&"
import script from "./TheAttachmentsList.vue?vue&type=script&lang=js&"
export * from "./TheAttachmentsList.vue?vue&type=script&lang=js&"
import style0 from "./TheAttachmentsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports